b {
  font-weight: 500;
}

.box-info::part(container) {
  padding: unset;
  width: 870px;
}

gz-info-box {
  padding: calc(2 * var(--spacer)) 0 0;
  line-height: 18px;
  --info-box-max-width: 870px;
}

#full-scan-task-text {
  color: var(--chart-300-icon-buttons);
}

gz-checkbox {
  width: auto;
}
